import { delete$, get$, post$ } from "./default";
import { api } from "../constants/api";

export const saveDealAPI = (data) => {
  return post$(api.deal.createDeal, data);
}

export const getDealAPI = (dealId) => {
  return get$(api.deal.getDeal.replace(":dealId", dealId));
};

export const getDealsAPI = (query) => {
  return get$(api.deal.getDeals, query);
};

export const deleteDealAPI = (dealId) => {
  return delete$(api.deal.deleteDeal.replace(":dealId", dealId));
};

export const updateStatusAPI = (dealId, data) => {
  return post$(api.deal.updateStatus.replace(":dealId", dealId), data);
};

export const addDealAPI = (dealId) => {
  return post$(api.deal.addDeal.replace(":dealId", dealId));
};

export const addStripeAccountAPI = () => {
  return post$(api.deal.addStripeAccount);
}

export const stripePayoutAPI = () => {
  return post$(api.deal.stripePayout);
}

// Gmail ITB Import APIs
export const getGmailConnectionStatusAPI = () => {
  return get$(api.deal.gmailConnectionStatus);
};

export const initiateGmailConnectAPI = () => {
  return get$(api.deal.gmailConnect);
};

export const disconnectGmailAPI = () => {
  return post$(api.deal.gmailDisconnect);
};

export const scanGmailInboxAPI = (data = {}) => {
  return post$(api.deal.scanGmailInbox, data);
};

export const scanGmailInboxStatusAPI = () => {
  return get$(api.deal.scanGmailInboxStatus);
};

export const listStagedITBsAPI = (params = {}) => {
  // Convert params object to query string
  const queryString = new URLSearchParams(params).toString();
  return get$(api.deal.listStagedITBs, queryString);
};

export const importITBsAPI = (data) => {
  return post$(api.deal.importITBs, data);
};

export const importITBsStatusAPI = () => {
  return get$(api.deal.importITBsStatus);
};

export const rejectITBAPI = (itbId) => {
  return post$(api.deal.rejectITB.replace(":itbId", itbId));
};
